(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chanukah-banner-depth"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chanukah-banner-depth')) {
    customElements.define('chanukah-banner-depth', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
        this.scene = this.querySelector('.sk-chanukah-depth__scene');
        this.addEventListener('pointermove', (event) => {
          if (!this.motion.matches || event.pointerType !== 'mouse') return;
          const rect = this.getBoundingClientRect();
          this.pointerX = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
          this.pointerY = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.setAttribute('data-active', '');
            this.scene.style.setProperty('--sk-tilt-x', `${(0.5 - this.pointerY) * 2.4}deg`);
            this.scene.style.setProperty('--sk-tilt-y', `${(this.pointerX - 0.5) * 2.4}deg`);
            this.scene.style.setProperty('--sk-depth-scale', '0.985');
            this.scene.style.setProperty('--sk-glow-x', `${this.pointerX * 100}%`);
            this.scene.style.setProperty('--sk-glow-y', `${this.pointerY * 100}%`);
          });
        }, options);
        this.addEventListener('pointerleave', () => this.reset(), options);
        this.addEventListener('pointercancel', () => this.reset(), options);
        this.motion.addEventListener('change', () => this.reset(), options);
      }

      reset() {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.removeAttribute('data-active');
        this.scene?.style.removeProperty('--sk-tilt-x');
        this.scene?.style.removeProperty('--sk-tilt-y');
        this.scene?.style.removeProperty('--sk-depth-scale');
      }

      disconnectedCallback() {
        this.reset();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chanukah-layered-scene"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chanukah-parallax')) {
    customElements.define('chanukah-parallax', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.pointerMedia = matchMedia('(hover:hover) and (pointer:fine)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
        this.currentX = this.currentY = this.targetX = this.targetY = 0;
        this.toggle = this.querySelector('.sk-parallax__motion');
        this.addEventListener('pointermove', (event) => {
          if (!this.pointerMedia.matches || this.reducedMotion.matches || this.hasAttribute('data-paused') || event.pointerType !== 'mouse') return;
          const rect = this.getBoundingClientRect();
          this.targetX = ((event.clientX - rect.left) / rect.width - .5) * 28;
          this.targetY = ((event.clientY - rect.top) / rect.height - .5) * 16;
          this.startFrame();
        }, options);
        this.addEventListener('pointerleave', () => this.recenter(), options);
        this.addEventListener('pointercancel', () => this.recenter(), options);
        this.reducedMotion.addEventListener('change', () => this.recenter(), options);
        this.toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          const paused = this.toggleAttribute('data-paused');
          const label = paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
          this.toggle.setAttribute('aria-pressed', String(paused));
          this.toggle.setAttribute('aria-label', label);
          this.toggle.title = label;
          this.recenter();
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-visible', entry.isIntersecting && !document.hidden);
          if (!entry.isIntersecting) this.recenter();
        }, {threshold:.05});
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => {
          this.toggleAttribute('data-visible', !document.hidden);
          if (document.hidden) this.recenter();
        }, options);
      }
      recenter() { this.targetX = this.targetY = 0; this.startFrame(); }
      startFrame() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.animatePointer());
      }
      animatePointer() {
        this.frame = 0;
        this.currentX += (this.targetX - this.currentX) * .1;
        this.currentY += (this.targetY - this.currentY) * .1;
        if (Math.abs(this.targetX - this.currentX) < .03 && Math.abs(this.targetY - this.currentY) < .03) {
          this.currentX = this.targetX; this.currentY = this.targetY;
        } else this.startFrame();
        this.style.setProperty('--mx', this.currentX.toFixed(3) + 'px');
        this.style.setProperty('--my', this.currentY.toFixed(3) + 'px');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame); this.frame = 0;
        this.observer?.disconnect(); this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-cart-po"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sk-cart-po')) {
  const po = { value:null, saved:null, timer:null, task:null, status:'', failed:false };
  const fields = () => [...document.querySelectorAll('sk-cart-po')];
  const paint = () => fields().forEach(field => {
    const input = field.querySelector('input');
    if (input.value !== po.value) input.value = po.value;
    field.toggleAttribute('data-error-state', po.failed);
    field.querySelector('[data-po-retry]').hidden = !po.failed;
    if (po.status) field.querySelector('[role="status"]').textContent = field.dataset[po.status];
  });
  const pending = () => po.task || po.value !== po.saved;
  const save = () => {
    clearTimeout(po.timer);
    if (po.task) return po.task;
    if (po.value === po.saved) return Promise.resolve(true);
    po.task = (async () => {
      try {
        po.failed = false;
        while (po.value !== po.saved) {
          const value = po.value;
          const url = fields()[0]?.dataset.updateUrl;
          if (!url) throw new Error();
          po.status = 'saving';
          paint();
          const response = await fetch(url, {
            method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
            body:JSON.stringify({ attributes:{ 'PO number':value } }), keepalive:true
          });
          const cart = await response.json();
          if (!response.ok || (cart.attributes?.['PO number'] || '') !== value) throw new Error();
          po.saved = value;
        }
        po.status = 'saved';
        paint();
        return true;
      } catch {
        po.failed = true;
        po.status = 'error';
        paint();
        return false;
      } finally {
        po.task = null;
      }
    })();
    return po.task;
  };
  customElements.define('sk-cart-po', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input');
      if (po.value === null) po.value = po.saved = input.value;
      paint();
      this.addEventListener('input', event => {
        if (event.target !== input) return;
        po.value = input.value;
        po.failed = false;
        po.status = 'saving';
        paint();
        clearTimeout(po.timer);
        po.timer = setTimeout(save, 300);
      });
      this.addEventListener('change', event => { event.stopPropagation(); save(); });
      this.querySelector('[data-po-retry]').addEventListener('click', save);
    }
  });
  document.addEventListener('click', event => {
    if (!pending() || event.defaultPrevented) return;
    const target = event.target.closest('a, button');
    if (!target) return;
    const href = target.getAttribute('href');
    const isCartLink = href && /\/(cart|checkout)\/?$/.test(new URL(href, location.href).pathname);
    if (!target.matches('[name="checkout"]') && !isCartLink) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    save().then(ok => { if (ok && target.isConnected) target.click(); });
  }, true);
  document.addEventListener('submit', event => {
    if (!pending() || !fields().some(field => field.querySelector('input').form === event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.target;
    const submitter = event.submitter;
    save().then(ok => { if (ok && form.isConnected) form.requestSubmit(submitter || undefined); });
  }, true);
  window.addEventListener('beforeunload', event => {
    if (pending()) { event.preventDefault(); event.returnValue = ''; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
